/* Full Page Intro Component JS File */
import ScrollMagic from 'ScrollMagic';
import 'animation.gsap';
import 'debug.addIndicators';
import TimelineMax from 'TimelineMax';
import Cookies from 'js-cookie';

function horizontalAnimation()
{
	const timeline = new TimelineMax();
	timeline﻿
	.add(function() {
		$(window).scrollTop(0);
		$("html").addClass('intro-active');
		$(".full-page-intro-wrapper").addClass('active');
	})
	.add(TweenMax.fromTo(".full-page-intro-wrapper .section-left .section-image .background", 1.2, { opacity: 0, scale: 1.1  }, { opacity: 1, scale: 1 }))
	.add(TweenMax.fromTo(".full-page-intro-wrapper .section-right .section-image .background", 1.2, { opacity: 0, scale: 1.1  }, { opacity: 1, scale: 1 }))
	.add([
		TweenMax.fromTo(".full-page-intro-wrapper .section-top", 1.2, { opacity: 0 }, { opacity: 1 }),
		TweenMax.fromTo(".full-page-intro-wrapper", 1.2, { backgroundColor: "#000000" }, { backgroundColor: "#ffffff" })
	])
	.add(TweenMax.fromTo(".full-page-intro-wrapper .section-bottom .section-logo", 1.2, { opacity: 0 }, { opacity: 1 }))
	.add(TweenMax.fromTo(".full-page-intro-wrapper .section-top .section-quote-wrapper", 1.2, { opacity: 1 }, { opacity: 0 }))
	.add(TweenMax.fromTo(".full-page-intro-wrapper .section-top .section-film-wrapper", 1.2, { opacity: 0 }, { opacity: 1 }))
	.add([
		TweenMax.to(".full-page-intro-wrapper .section-bottom .section-logo", 1.2, { backgroundColor: "#ffffff" }),
		TweenMax.to(".full-page-intro-wrapper .section-bottom .section-logo svg path", 1.2, { fill: "#000000" })
	])
	.add([
		TweenMax.to(".full-page-intro-wrapper .section-right .section-image .background", 1.2, { opacity: 0 }),
		TweenMax.to(".full-page-intro-wrapper .section-left .section-image .background", 1.2, { opacity: 0 }),
		TweenMax.to(".full-page-intro-wrapper .section-top", 1.2, { backgroundColor: "#ffffff" }),
		TweenMax.to(".full-page-intro-wrapper .section-top .section-intro-text h3", 1.2, { color: "#000000" })
	])
	.add([
		TweenMax.to(".full-page-intro-wrapper .section-top", 1.2, { opacity: 0 }),
		TweenMax.to(".full-page-intro-wrapper .section-bottom", 1.2, { opacity: 0 })
	])
	.add(function() {
		setTimeout(function() {
			$("html").removeClass('intro-active');
			$(".full-page-intro-wrapper").removeClass('active');
			Cookies.set('intro-played', 1);
		}, 1000);
	});
}

function verticalAnimation()
{
	const timeline = new TimelineMax();
	timeline﻿
	.add(function() {
		$(window).scrollTop(0);
		$("html").addClass('intro-active');
		$(".full-page-intro-wrapper").addClass('active');
	})
	.add([
		TweenMax.fromTo(".full-page-intro-wrapper .section-left .section-image .background", 1.2, { opacity: 0, scale: 1.1  }, { opacity: 1, scale: 1 }),
		TweenMax.to(".full-page-intro-wrapper .section-top", 2, { opacity: 1, delay: 2 }),
		TweenMax.to(".full-page-intro-wrapper .section-left .section-image .background", 1.2, { opacity: 0, delay: 1.5 })
	])
	.add(TweenMax.to(".full-page-intro-wrapper .section-top .section-quote-wrapper", 1.2, { opacity: 0 }))
	.add([
		TweenMax.fromTo(".full-page-intro-wrapper .section-right .section-image .background", 1.2, { opacity: 0, scale: 1.1  }, { opacity: 1, scale: 1 }),
		TweenMax.to(".full-page-intro-wrapper .section-bottom .section-logo", 2, { opacity: 1, delay: 2 }),
		TweenMax.to(".full-page-intro-wrapper .section-right .section-image .background", 1.2, { opacity: 0, delay: 1.5 })
	])
	.add([
		TweenMax.to(".full-page-intro-wrapper .section-bottom .section-logo", 1.2, { opacity: 0, delay: 1 }),
		TweenMax.to(".full-page-intro-wrapper", 1.2, { backgroundColor: "#ffffff" }),
		TweenMax.to(".full-page-intro-wrapper .section-top .section-film-wrapper .section-intro-text h3", 1.2, { color: "#000000", delay: 2 }),
		TweenMax.to(".full-page-intro-wrapper .section-top .section-film-wrapper", 1.2, { opacity: 1, delay: 2 })
	])
	.add(function() {
		setTimeout(function() {
			$("html").removeClass('intro-active');
			$(".full-page-intro-wrapper").removeClass('active');
			Cookies.set('intro-played', 1);
		}, 1000);
	});
}

$(document).ready(function() {
	const ww = $(window).width();
	if ($(".full-page-intro-wrapper").length) {
		const introPlayed = Cookies.get('intro-played');
		if (typeof introPlayed === 'undefined') {
			$(window).on('load rotate', function() {
				if (ww <= 567) {
					verticalAnimation();
				} else if (ww >= 568 && ww <= 767) {
					horizontalAnimation();
				} else if (ww >= 768 && ww <= 991) {
					verticalAnimation();
				} else if (ww >= 992) {
					horizontalAnimation();
				}
			})
		}
	}
});
